import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { RippleModule } from "primeng/ripple";
import { SkeletonModule } from "primeng/skeleton";
import { TagModule } from "primeng/tag";
import { TooltipModule } from "primeng/tooltip";

@Component({
    selector: "app-nav-context-header",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, TranslateModule, TooltipModule, RippleModule, TagModule, SkeletonModule],
    templateUrl: "./nav-context-header.component.html",
    styleUrl: "./nav-context-header.component.scss",
})
export class NavContextHeaderComponent {

    // =========================================================================
    // INPUTS
    // =========================================================================
    public readonly expanded = input.required<boolean>();
    public readonly backRoute = input.required<string[] | null>();
    public readonly backLabel = input.required<string>();
    // When true, only the back link is rendered (no title/subtitle/status/lock).
    public readonly hideIdentity = input(false);
    public readonly title = input<string>("");
    public readonly subtitle = input<string | null>(null);
    public readonly loading = input(false);
    public readonly statusLabel = input<string | null>(null);
    public readonly statusIcon = input<string | null>(null);
    public readonly statusSeverity = input<"success" | "secondary" | "info" | "warn" | "danger" | "contrast" | null>(null);
    public readonly locked = input(false);
    public readonly lockTooltip = input<string | null>(null);
}
